import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./InfosUser.module.scss";
import { RiAdminFill, RiUserAddFill } from "react-icons/ri";
import { IoMdCopy, IoMdInformationCircleOutline } from "react-icons/io";
import Axios from "../../../_services/caller.service";
import Select from "react-select";
import { toast } from "react-toastify";
import SendEmailToResetPassword from "./SendEmailToResetPassword";


const InfosConnexion = ({
  setDisplayConnectingUser,
  displayConnectingUser,
  infosUser,
  ownerId,
  setOwnerId,
}) => {
  const { t } = useTranslation();
  const [displayInfos, setDisplayInfos] = useState(false);
  const [infosCabAccess, setInfosCabAccess] = useState([]);
  const [noAccess, setNoAccess] = useState("");

  useEffect(() => {
    Axios.get(`/infosCabAccess/${ownerId}`)

      .then(function async(response) {
        if (response.data.message === "aucun acces") {
          setNoAccess("Aucun accès aux cabines pour cet utilisateur");
          setInfosCabAccess([]);
        } else {
          setInfosCabAccess(response.data.data);
          setNoAccess("");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [ownerId, setOwnerId]);

  // display user's role
  const displayRole = (role) => {
    if (role === 8) {
      return t("roles.calibration");
    }
    if (role === 1) {
      return t("roles.consultation");
    }
    if (role === 256) {
      return t("roles.admin");
    }
    if (role === 2147483647) {
      return t("roles.owner_cabine");
    }
  };

  const options =
    infosCabAccess.length >= 1 &&
    infosCabAccess.map((cab) => ({
      value: cab.id, // l'identifiant de la cabine
      label: `${cab.cabname} - Role: ${displayRole(cab.role)}`, // le texte à afficher
      role: cab.role,
    }));

  const customStyles = {
    option: (provided, state) => {
      // Définir des styles personnalisés pour les options où le rôle est "Owner de la cabine"
      if (state.data.role === 2147483647) {
        return {
          ...provided,
          backgroundColor: "lightgreen", // Couleur de fond verte pour le rôle "Owner de la cabine"
          color: "black", // Couleur de texte pour le rôle "Owner de la cabine"
        };
      }

      // Styles par défaut pour les autres options
      return {
        ...provided,
        backgroundColor: "white",
        color: "black",
      };
    },
    // Vous pouvez ajouter d'autres styles personnalisés si nécessaire
  };

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(infosUser.user_email).then(
      () => {
        toast(t("superadmin_ui.email_copied_clipboard"));
      },
      (err) => {
        console.error("Erreur lors de la copie : ", err);
      }
    );
  };
  return (
    <div className={styles.containerInfosConnexion}>
      <RiAdminFill className={styles.adminIcon} />

      <span className={styles.ownerName}>{infosUser.display_name}</span>
      <span className={styles.separator}>·</span>
      <span className={styles.ownerMeta}>{infosUser.user_login}</span>

      {/* Tooltip au survol avec ID + email */}
      <div className={styles.tooltipWrap}>
        <IoMdCopy
          className={styles.copyIcon}
          onClick={handleCopyEmail}
          title={t("common.copy_email")}
        />
        <div className={styles.tooltip}>
          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>ID</span>
            <span className={styles.tooltipValue}>{infosUser.ID}</span>
          </div>
          <div className={styles.tooltipRow}>
            <span className={styles.tooltipLabel}>Email</span>
            <span className={styles.tooltipValue}>{infosUser.user_email}</span>
          </div>
        </div>
      </div>

      <SendEmailToResetPassword
        email={infosUser.user_email}
        userLogin={infosUser.user_login}
      />
    </div>
  );
};

export default InfosConnexion;



